import { useState, useEffect } from 'react';

const boardMembers = [
  {
    name: 'Pastor Ituah Ighodalo',
    title: 'Chairman, Board of Directors',
    image: 'https://storage.readdy-site.link/project_files/03018834-26ba-4d8a-b68a-dd604919fadb/12ca2234-eadf-4e07-883b-61027293856a_ITUAH.jpg?v=1ce8252cd29ee6a7dbd5828fd8b601ca',
    bio: 'Ituah Ighodalo is a Corporate Business Leader with an extensive track record in building and sustaining major establishments and institutions. He possesses over 40 years\' experience in Auditing, Accounting, Taxation, Human resources and Financial Advisory Services. Ituah is a fellow of the Institute of Chartered Accountants of Nigeria (ICAN). A Fellow of the Chartered Institute of Taxation Nigeria, a member of the Institute of Management, a member of the American Society of Industrial Security and a member of the American Institute of Management. He sits on the board of several corporate, charitable organizations and NGOs, as Chairman and Director. He also Serves as the Senior Pastor, Trinity House.',
    linkedin: '#',
    active: true,
  },
  {
    name: 'Victor Ukwat',
    title: 'Co-Founder | CEO',
    image: 'https://storage.readdy-site.link/project_files/03018834-26ba-4d8a-b68a-dd604919fadb/acd0ad9c-80fa-4aad-a926-f708b139e5e8_UKKY.jpg?v=01c635a9962dfecce5fc25114db3d1eb',
    bio: 'Victor Ukwat is an alumnus of Senior Strategy, Management and Leadership Programmes from top global institutions, notably the Columbia Business School in New York, USA; the Schulich Business School in Toronto, Canada; and the SAID Business School in Oxford, England, where he obtained certifications in High-Impact Leadership, Strategic Leadership, and High-Performance Leadership respectively. He also attended the prestigious Harvard Business School (USA), and the IESE Business School (Spain) where he obtained certifications in Building New Businesses In Established Companies and Entrepreneurship. He holds a Bachelor\'s degree in Science (B.Sc) from the University of Calabar, a Masters in Science from the University of Ibadan and a Masters in Business Administration from the Lagos Business School (LBS). He is also a member of the Institute of Directors, Nigeria (IOD) and a Fellow of the National Institute of Marketing of Nigeria (NIMN). Victor Ukwat is a trained Executive Coach from Hult Ashridge, UK.',
    linkedin: '#',
    active: true,
  },
  {
    name: 'Jayson Oyarekhua',
    title: 'Co-Founder | Executive Director',
    image: 'https://storage.readdy-site.link/project_files/03018834-26ba-4d8a-b68a-dd604919fadb/ecd75480-f2fa-47d2-9da7-c001dd7149ef_IMG_8970.jpeg?v=f18cdd1a0b613730f70b376b1fa2f9c7',
    bio: 'Jayson Oyarekhua is a highly experienced Business Leader with a background in Management, Logistics, e-commerce, and Technology | Enterprise Solutions. He has held multiple cross-functional professional positions in Corporate Leadership, Operations, Sales and Strategy, e-commerce, and Technology. He has designed and implemented product distribution solutions with a focus on e-commerce and end-to-end order fulfillment. As Chief Operating Officer at FedEx Red Star Express Nigeria, Jayson was responsible for overseeing all aspects of the company\'s sales, operations; including Transportation Management, Order Fulfillment, and Customer Experience Management. He is a strategic and analytical thinker with excellent communication and transformational leadership skills. He is also committed to staying up to date with the latest trends and developments in the industry. In addition to his professional experience, Jayson holds a Masters of Business Administration (MBA) from the Ambrose Alli University, Ekpoma and is an alumnus of Leadership, Management and Strategic programs from SAID Business School in Oxford (UK), Wharton Business School (USA), University of California Irvine, USA, Lagos Business School (LBS) in Lagos, and FedEx Purple Academy in Dubai (UAE). He has also undergone various Logistics programs from the University of Westminster (UK).',
    linkedin: '#',
    active: true,
  },
  { name: '', title: 'Director', image: '', bio: '', linkedin: '#', active: false },
  { name: '', title: 'Director', image: '', bio: '', linkedin: '#', active: false },
  { name: '', title: 'Director', image: '', bio: '', linkedin: '#', active: false },
  { name: '', title: 'Director', image: '', bio: '', linkedin: '#', active: false },
];

const leadershipTeam = [
  { name: '', title: '', image: '', bio: '', linkedin: '#', active: false },
  { name: '', title: '', image: '', bio: '', linkedin: '#', active: false },
  { name: '', title: '', image: '', bio: '', linkedin: '#', active: false },
  { name: '', title: '', image: '', bio: '', linkedin: '#', active: false },
  { name: '', title: '', image: '', bio: '', linkedin: '#', active: false },
  { name: '', title: '', image: '', bio: '', linkedin: '#', active: false },
];

interface TeamMember {
  name: string;
  title: string;
  image: string;
  bio: string;
  linkedin: string;
  active: boolean;
}

interface BioModalProps {
  member: TeamMember;
  onClose: () => void;
}

function BioModal({ member, onClose }: BioModalProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-6"
      style={{ background: 'rgba(0,0,0,0.80)', backdropFilter: 'blur(8px)' }}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-3xl rounded-2xl overflow-hidden flex flex-col"
        style={{ background: '#13131f', border: '1px solid rgba(232,25,44,0.25)', maxHeight: '90vh' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-1 w-full shrink-0" style={{ background: 'linear-gradient(90deg, #E8192C, transparent)' }} />
        <div className="flex flex-col sm:flex-row overflow-hidden min-h-0">
          <div className="sm:w-56 shrink-0 h-56 sm:h-auto">
            <img src={member.image} alt={member.name} className="w-full h-full object-cover object-top" />
          </div>
          <div className="flex-1 flex flex-col overflow-hidden">
            <div className="shrink-0 px-7 pt-7 pb-4">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="text-white font-bold text-xl leading-tight">{member.name}</h3>
                  <p className="text-thl-red text-xs font-semibold uppercase tracking-widest mt-1.5">{member.title}</p>
                </div>
                <button
                  onClick={onClose}
                  className="w-8 h-8 flex items-center justify-center rounded-lg shrink-0 text-white/40 hover:text-white hover:bg-white/10 transition-all duration-200 cursor-pointer"
                >
                  <i className="ri-close-line text-lg" />
                </button>
              </div>
              <div className="h-px bg-white/10 mt-4" />
            </div>
            <div className="flex-1 overflow-y-auto px-7 pb-4" style={{ scrollbarWidth: 'thin', scrollbarColor: '#E8192C #13131f' }}>
              <p className="text-white/75 text-sm leading-relaxed">{member.bio}</p>
            </div>
            <div className="shrink-0 px-7 py-5 border-t border-white/10 flex items-center gap-3">
              {member.linkedin !== '#' && (
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2 rounded-lg border border-white/15 hover:border-thl-red/50 text-white/60 hover:text-thl-red text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-linkedin-fill" />
                  <span>LinkedIn</span>
                </a>
              )}
              <button
                onClick={onClose}
                className="px-5 py-2 rounded-lg text-sm font-semibold text-white/50 hover:text-white border border-white/10 hover:border-white/30 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function PlaceholderCard() {
  return (
    <div className="h-[400px] rounded-xl border border-white/8 flex flex-col items-center justify-center gap-4"
      style={{ background: 'rgba(255,255,255,0.02)' }}>
      <div className="w-14 h-14 flex items-center justify-center rounded-full border border-white/10"
        style={{ background: 'rgba(255,255,255,0.04)' }}>
        <i className="ri-user-line text-white/20 text-2xl" />
      </div>
      <p className="text-white/20 text-xs uppercase tracking-widest font-medium">Coming Soon</p>
    </div>
  );
}

interface TeamGridProps {
  members: TeamMember[];
  onReadMore: (member: TeamMember) => void;
}

function TeamGrid({ members, onReadMore }: TeamGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {members.map((member, idx) => {
        if (!member.active) {
          return <PlaceholderCard key={idx} />;
        }
        return (
          <div key={member.name} className="flip-card h-[400px] cursor-pointer">
            <div className="flip-card-inner">
              {/* FRONT */}
              <div className="flip-card-front relative">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/25 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-white font-bold text-base leading-tight">{member.name}</h3>
                  <p className="text-thl-red text-xs font-semibold uppercase tracking-wide mt-1">{member.title}</p>
                  <div className="mt-3 flex items-center gap-1.5 text-white/35 text-xs">
                    <i className="ri-loop-right-line text-sm" />
                    <span>Hover to learn more</span>
                  </div>
                </div>
              </div>
              {/* BACK */}
              <div className="flip-card-back bg-thl-dark3 border border-thl-red/30 flex flex-col justify-between p-5">
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-thl-red/10 border border-thl-red/30 shrink-0">
                      <i className="ri-user-line text-thl-red text-lg" />
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-sm leading-tight">{member.name}</h3>
                      <p className="text-thl-red text-xs font-semibold uppercase tracking-wide mt-0.5">{member.title}</p>
                    </div>
                  </div>
                  <p className="text-white/60 text-xs leading-relaxed line-clamp-6">{member.bio}</p>
                </div>
                <div className="flex items-center gap-2 mt-4">
                  <button
                    onClick={() => onReadMore(member)}
                    className="flex-1 btn-primary text-xs py-2 text-center"
                  >
                    Read More
                  </button>
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/15 hover:border-thl-red/50 text-white/50 hover:text-thl-red transition-all duration-200"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <i className="ri-linkedin-fill text-base" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function MeetTheTeamSection() {
  const [activeMember, setActiveMember] = useState<TeamMember | null>(null);

  return (
    <>
      {/* Board of Directors */}
      <section className="py-24 px-6" style={{ background: '#0c0c14' }}>
        <div className="max-w-7xl mx-auto">
          <div className="mb-14">
            <p className="eyebrow">Governance</p>
            <h2 className="section-heading mb-3">Board of Directors</h2>
            <p className="text-white/50 text-sm max-w-xl leading-relaxed">
              Distinguished leaders providing strategic oversight, governance, and the networks
              that propel THL forward. Hover over each card to learn more.
            </p>
          </div>
          <TeamGrid members={boardMembers} onReadMore={setActiveMember} />
        </div>
      </section>

      {/* Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-thl-red/30 to-transparent mx-6" />

      {/* Leadership Team */}
      <section className="py-24 px-6" style={{ background: '#0f0f18' }}>
        <div className="max-w-7xl mx-auto">
          <div className="mb-14">
            <p className="eyebrow">Our People</p>
            <h2 className="section-heading mb-3">Leadership Team</h2>
            <p className="text-white/50 text-sm max-w-xl leading-relaxed">
              Operators, builders, and problem-solvers running THL day to day,
              united by a mission to transform logistics across Africa.
            </p>
          </div>
          <TeamGrid members={leadershipTeam} onReadMore={setActiveMember} />
        </div>
      </section>

      {/* Bio Modal */}
      {activeMember && (
        <BioModal member={activeMember} onClose={() => setActiveMember(null)} />
      )}
    </>
  );
}
